import { useState, type FormEvent } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { AuthLayout } from "../app/layouts/AuthLayout";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";
import { apiClient, ApiError } from "../lib/api-client";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await apiClient.post("/api/auth/reset-password", { json: { token, password } });
      navigate("/login?reset=ok", { replace: true });
    } catch (err) {
      if (err instanceof ApiError && err.status === 400) {
        setError("Link is invalid or has expired.");
      } else {
        setError("Could not reset password. Try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (!token) {
    return (
      <AuthLayout title="Reset password" subtitle="No token provided.">
        <Link to="/forgot-password" className="link">Request a new link</Link>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout title="Choose a new password">
      <form onSubmit={onSubmit} className="form-stack">
        <Input
          label="New password"
          type="password"
          minLength={8}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error ? <div className="form-error">{error}</div> : null}
        <Button type="submit" disabled={submitting}>
          {submitting ? "Saving…" : "Set password"}
        </Button>
      </form>
    </AuthLayout>
  );
}
